import ICCardRecorderNotAll from './ICCardRecorderNotAll';

export default ICCardRecorderNotAll;
